<template>
    <div class="user-wrapper w-100">
      <profile-header></profile-header>
      <div class="user-content">
        <div class="container">
          <div class="my-auto w-100 main-area" style="margin-bottom: 20px !important;">
            <div class="profile-detail">
              <div class="profile-detail-block">
                <!-- Content of the profile-detail block -->
                <slot></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
      <slot name="footer"></slot>
    </div>
  </template>
<script>
import ProfileHeader from "@/components/header.vue";
    export default {
        name: 'UserWrapper',
        components: { ProfileHeader }
    };
</script>
  